export default "__VITE_ASSET__CjxzkjoS__"